import styled from 'styled-components';

const DivQualiopiWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 0;
  margin-top: auto;
`;

const DivQualiopiLogo = styled.div`
  text-align: center;
  background-color: white;
  padding: 1em;
  border-radius: 15px;
  max-width: 250px;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`;

const PText = styled.p`
  margin-top: 1em;
  font-size: 10px;
  line-height: 14px;
`;

export default {
  DivQualiopiWrapper,
  DivQualiopiLogo,
  PText,
};
